import { Component } from '@angular/core';
import { Features } from '@core/feature-preview/features';
import { FeaturePreviewStatus } from '@core/feature-preview/types/feature-preview';
import { FeaturePreviewListComponent } from '@core/feature-preview/dialog/feature-preview-list.component';

@Component({
  selector: 'app-feature-preview-dialog',
  imports: [FeaturePreviewListComponent],
  template: ` <app-feature-preview-list [features]="features" /> `,
})
export class FeaturePreviewDialogComponent {
  features = Object.values(Features || {}).filter(
    feature => feature.status === FeaturePreviewStatus.PREVIEW
  );
}
